export const DYNAMIC_REPORT_MODE = 'dynamic-report-mode';
